/**
 * Class names for Delimiter
 */
export const enum DelimiterClasses {
    /**
     * Class name to specify this delimiter is before an entity
     */
    DELIMITER_BEFORE = 'entityDelimiterBefore',

    /**
     *  Class name to specify this delimiter is after an entity
     */
    DELIMITER_AFTER = 'entityDelimiterAfter',
}
